import { InjectionToken } from '@angular/core';
import { FirebaseOptions } from '@angular/fire/app';

export interface EnvConfig {
  readonly environment: 'local' | 'stage' | 'prod';
  readonly production: boolean;
  readonly apiUrl: string;
  readonly frontendUrl: string;
  readonly domain: string;
  readonly firebase: FirebaseOptions;
  readonly androidApkUrl: string;
  readonly iOSApkUrl: string;
  readonly sentryDsn?: string;
  readonly unleash?: {
    readonly url: string;
    readonly clientKey: string;
    readonly appName: string;
  };
}

export const ENV_CONFIG: InjectionToken<EnvConfig> = new InjectionToken<EnvConfig>('ENV_CONFIG');
